import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRelatedBlogsAsync } from "./RelatedBlogsAPI";

const sliceName = "relatedBlogs";
const initialState = {
    blogs: [],
    isLoading: false,
    isError: false,
    errorMessage: ''
};

export const fetchRelatedBlogs = createAsyncThunk(`${sliceName}/fetchRelatedBlogs`, getRelatedBlogsAsync);

const relatedBlogsSlice = createSlice({
    name: sliceName,
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchRelatedBlogs.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(fetchRelatedBlogs.fulfilled, (state, action) => {
                state.isLoading = false;
                state.blogs = action.payload;
            })
            .addCase(fetchRelatedBlogs.rejected, (state, action) => {
                state.isError = true;
                state.isLoading = false;
                state.errorMessage = action.error?.message;
                state.blogs = [];
            });
    }
});

export default relatedBlogsSlice.reducer;
